import { render, staticRenderFns } from "./RipaRadioGroup.vue?vue&type=template&id=abe8c6a4"
import script from "./RipaRadioGroup.vue?vue&type=script&lang=js"
export * from "./RipaRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports